import axios from "../../utils/axiosInstanse"
import {BASE_URL} from "../../constants/urls";


/**
 * Put api with token
 * @param {Object} data
 * @param {string} path
 * @returns {Promise}
 */
const putApi = (data, path) => {
    return axios.put(
        BASE_URL + path, data
    )
}


export {
    putApi
}
